import store from "store2";
import { Message } from "element-ui";
import DynamicRoute from '@/common/router/module/dynamic'

/**
 * 跳转到V2系统
 * @param {Object} params - 跳转参数
 * @param {string} params.path - 跳转路径
 * @param {string} params.appid - 应用ID
 * @param {boolean} params.target - 是否在当前窗口跳转
 * @param {boolean} params.noToken - 是否不需要token
 */
export function goNewSys(params = {}) {
  const v2LoginData = store.get("v2LoginData") || {};
  const env = process.env;
  let url =
    env.NODE_ENV == "development"
      ? "http://localhost:8848"
      : env.NODE_ENV == "production"
        ? "https://zt.nineton.cn" :
        env.NODE_ENV == "test" ? 'http://124.70.208.39:39009'
          : "https://zt.nineton.cn";

  let url_v2 = `${url}/#/loading?path=${params.path || ""}&appid=${params.appid || ""}`
  if (v2LoginData.token) {
    // 生成跳转链接
    url_v2 = url_v2 + `&token=${encodeURIComponent(v2LoginData.token)}`;
  } else if (!v2LoginData.token && !params.noToken) {
    return Message.warning("无法获取V2的登录权限，请尝试重新登录获取！");
  }


  if (params.target) {
    // 如果有target只在当前窗口进行跳转
    window.location.href = url_v2;
  } else {
    window.open(url_v2, "ztadmin");
  }
}

// 读取本地的用户信息
export function getLocalUserInfo() {
  return store.get("user") || {};
}


// 判断是否需要跳转v2
export async function checkNeedGoV2(to) {
  // 通过vuex获取app应用列表
  const adminInfo = store.get("user") || {};
  const { meta } = to
  const isCountCenter = to.path.includes("/count_center");
  const appid = to.query.appId || '';
  // 需要强制跳转v2
  if (meta.isForcedRedirectV2) {
    goNewSys({
      path: meta.path_v2 || to.path,
      appid: appid,
      target: true,
    });
    return false;
  }

  //    统计中心，且是v2链接，且需要跳转
  if (isCountCenter && meta.is_v2_link && adminInfo.redirect_to_zt == 1) {
    goNewSys({
      path: meta.path_v2 || to.path,
      appid: appid,
      target: true,
    });

    return false
  }

  // 非统计中心，且是v2链接，且需要跳转
  if (!isCountCenter && meta.is_v2_link && adminInfo.redirect_to_zt == 1) {
    goNewSys({
      path: meta.path_v2 || to.path,
      target: true,
    });
    return false
  }

  // 不需要任何操作继续执行router
  return true

}

// 跳转v2登录页面
export function goV2Login(to) {
  const env = process.env;
  let url =
    env.NODE_ENV == "development"
      ? "http://localhost:8848"
      : env.NODE_ENV == "production"
        ? "https://zt.nineton.cn"
        : env.NODE_ENV == "test"
          ? "http://124.70.208.39:39009"
          : "https://zt.nineton.cn";
  if (to && to.path && to.path != '/login') {
    // 把路由扁平化
    const flattenRoutes = (routes) => {
      return routes.reduce((acc, route) => {
        if (Array.isArray(route.children) && route.children.length) {
          acc.push(...flattenRoutes(route.children));
        } else {
          acc.push(route);
        }
        return acc;
      }, []);
    };
    const routes = flattenRoutes(DynamicRoute())
    // 找到to.path的位置
    const item = routes.find(item => item.path === to.path)
    if (item) {
      goNewSys({
        path: item.path_v2 || item.path,
        appid: to.query.appId || '',
        target: true,
        noToken: true,
      });
    }
  } else {
    // 直接跳转登录页
    (window.location.href = `${url}/#/login`);
  }
} 